/**
 * Devex namespace
 *
 * @type {object}
 */
devex = devex || {};

/**
 * User namespace
 *
 * @type {object}
 */
devex.user = devex.user || {};

/**
 * Set the user session cookie in the browser.
 *
 * @param {string} sessionId The cookie
 * @returns {undefined}
 */
devex.user.signIn = function (sessionId) {
  devex.util.setCookie('dxvisa', sessionId, 365);
};

/**
 * jQuery Ajax request to gather user data. We now save it in the global scope
 * in order to avoid duplicating requests.
 *
 * @type {jqXHR}
 */
devex.user.getUserDataRequest = null;

/**
 * get the user data
 * if the request has already been fired, we will then register the success
 * callback passed as argument in the running or resolved request, using
 * jQuery chaining capabilities.
 *
 * @param {Function} callback To be executed with parsed data or null
 * @returns {undefined}
 */
devex.user.getData = function (callback) {
  // If the promise already runs or is resolved, register incoming success
  // callback
  if (devex.user.getUserDataRequest) {
    return devex.user.getUserDataRequest.promise().then(callback);
  }

  devex.user.getUserDataRequest = $.ajax({
    url: devex.data.settings.userDataEndpoint,
    type: 'GET',
  });
  devex.user.getUserDataRequest.done(function (data) {
    var parsedData = null;

    if (typeof data === 'string') {
      parsedData = JSON.parse(data);
    }
    if (typeof data !== 'object') {
      parsedData = null;
    } else {
      data.package_combination_name = data.package_combination_name || '';
      data.company_name = data.company_name || '';
      parsedData = data;
    }
    devex.data.user = parsedData;

    // If user is a Devexer, disable all Plausible tracking for specific browser.
    if (parsedData.company_name === 'Devex' && location.host === 'www.devex.com') {
      localStorage.setItem('plausible_ignore', 'true');
    }

    callback(parsedData, null);
  });
  devex.user.getUserDataRequest.fail(function () {
    callback(null, true);
  });
};

/**
 * check if the user has one of many packages
 *
 * @param {Array} packages List of packages to be checked
 * @returns {boolean} true if user has the package, otherwise false
 */
devex.user.hasPackageViaShortname = function (packages) {
  var packagesArray = packages;
  if (!Array.isArray(packages)) {
    packagesArray = [packages];
  }
  return packagesArray.some(function (required_package) {
    return (
      typeof devex.data.user.packages !== 'undefined' &&
      devex.data.user.packages.indexOf(required_package) >= 0
    );
  });
};

/**
 * check if the user has a package matching with any of the provided ones
 *
 * @param {Array} packages List of packages to be checked
 * @returns {boolean} true if user has the package, otherwise false
 */
devex.user.matchPackageViaShortname = function (packages) {
  var packagesArray = packages;
  if (!Array.isArray(packages)) {
    packagesArray = [packages];
  }
  return (
    typeof devex.data.user.packages !== 'undefined' &&
    devex.data.user.packages.some(function (item) {
      return item.match(packagesArray.join('|'));
    })
  );
};

/**
 * check if current user is linked to a company. Require devex.user.getData()
 * function to have been previously called
 *
 * @returns {boolean} isLinkedToCompany
 */
devex.user.isLinkedToCompany = function () {
  return devex.data.user.company_id && devex.data.user.company_id !== null;
};

/**
 * check if current user have opted out the email notifications
 *
 * @param {Function} callback - Handle the async response
 */
devex.user.canReceiveNotifications = function (callback) {
  $.ajax({
    url: '/api/email_settings/opted_out_of_all_emails',
    type: 'GET',
  })
    .done(function (response) {
      callback(!response);
    })
    .fail(function () {
      // If any error happens while doing the request we return true, as it's the
      // default and the most common config for the users
      callback(true);
    });
};

/**
 * Use the `navigation.credentials` API to automatically log the user in (if API is available).
 * After a successful login, it reloads the page. If the login was not successful, the auto-login
 * feature will be deactivated until the next successful manual login.
 *
 * @returns {undefined}
 */
devex.user.autoLogin = function () {
  if (!devex.user.canAutoLogin()) {
    return;
  }

  navigator.credentials
    .get({
      password: true,
      mediation: 'optional',
    })
    .then(function (cred) {
      if (cred) {
        $.ajax({
          url: Routes.login_path(),
          method: 'POST',
          data: {
            login: cred.id,
            password: cred.password,
          },
        })
          .then(function () {
            location.reload();
          })
          .fail(function () {
            // After an unsuccessful auto-login, don't try to auto-login again
            devex.user.preventAutoLogin();
            // In order to test the function, check if we are in develop
            if (window.location.href.indexOf('develop') !== -1) {
              // If the auto-login fails, redirect to login and shows an error message.
              window.location.replace(Routes.login_path() + '?invalid=1');
            }
          });
      } else {
        devex.user.preventAutoLogin();
      }
    });
};

/**
 * Prevent the browser from automatically logging the user back in
 *
 * @returns {undefined}
 */
devex.user.preventAutoLogin = function () {
  var currentDate = new Date();
  localStorage.setItem('preventAutoLogin', currentDate.getTime().toString());
  if (window.PasswordCredential) {
    navigator.credentials.preventSilentAccess();
  }
};

/**
 * Checks if the current user can use the auto-login functionality
 *
 * @returns {boolean} true if user can use auto-login, otherwise false
 */
devex.user.canAutoLogin = function () {
  // Check if the API is available
  if (!window.PasswordCredential) {
    return false;
  }

  // Check if the `preventAutoLogin` flag has been set
  var preventAutoLogin = localStorage.getItem('preventAutoLogin');
  if (!preventAutoLogin) {
    return true;
  }

  // If it has been set, check if it's older than 8 hours. If so, return `true`.
  // Eight hours were chosen to reflect a user who logs out at the end of a working
  // day. This way, the next day the user will be signed in again.
  var logoutDate = new Date(parseInt(preventAutoLogin));
  return logoutDate < new Date().getTime() - 8 * 60 * 60 * 1000;
};
